import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CustomModal from './CustomModal';

function DemoModal({ show, setShow, onClose, onAction }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleClose = () => {
        setShow(false);
        onClose?.();
    };

    const handleAction = () => {
        handleClose();
        onAction();
    };

    const handleViewPlans = () => {
        navigate('/pricing');
    };

    return (
        <CustomModal
            show={show}
            onClose={handleClose}
            title={t('modal.demo.title')}
            messageHtml={t('modal.demo.messageHtml')}
            closeLabel={t('modal.demo.closeBtn')}
            actionLabel={t('modal.demo.actionBtn')}
            actionClassName="bg-pink"
            onAction={handleAction}
            onCloseButton={handleViewPlans}
        />
    );
}

export default DemoModal;
